import React, { useCallback, } from 'react';
import { useLocation } from 'react-router-dom';
import { pipe, } from 'ramda';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Box from '@material-ui/core/Box';

import { makeDialogTitleStyles, } from 'styles/components/availability';
import Button from 'common/components/Button';

type Props = {
    handleClose: () => void,
    open: boolean,
};

const SessionExpiredDialog: React.FC<Props> = ({ open, handleClose, }) => {
    const location = useLocation();
    const dialogTitleClasses = makeDialogTitleStyles();

    const handleConfirm = useCallback(
        pipe(
            handleClose,
            () => window.location.replace('/login'),
        ),
        [ handleClose, ]
    );

    if (location.pathname.includes('/login')) {
        return null;
    }

    return (
        <Dialog fullWidth
                maxWidth="sm"
                open={open}>
            <DialogTitle classes={dialogTitleClasses}
                         disableTypography>
                <Typography component="h4"
                            variant="h6">
                    Uwaga
                </Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Twoja sesja wygasła, zaloguj się ponownie.
                </DialogContentText>
                <Box display="flex"
                     justifyContent="center"
                     margin="2.5rem auto 1rem"
                     maxWidth="18rem"
                     width="100%">
                    <Button onClick={handleConfirm}>
                        OK
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default SessionExpiredDialog;
